/* Bella K Relaunch: Kreatin in 30 Sekunden (bkr-explainer-mini, PDP).
   Quelle: prototypes/v3d/main.js („Figures in the PDP mini explainer“).
   Jede Figur baut sich beim Sichtbarwerden auf und läuft nur, solange sie sichtbar ist. */
(function () {
  if (!window.bkr) return;
  var bkr = window.bkr;

  bkr.section('.s-explainer-mini', function (root) {
    var figs = bkr.$$('.xp-fig', root);
    if (bkr.reduce || !('IntersectionObserver' in window)) {
      figs.forEach(function (f) { f.classList.add('is-on'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (x) {
        if (x.isIntersecting) x.target.classList.add('is-on');
        x.target.classList.toggle('is-live', x.isIntersecting);
      });
    }, { threshold: 0.35 });
    figs.forEach(function (f) { io.observe(f); });
    return function () { io.disconnect(); };
  });
})();
